import { render } from "./CastMovie.vue?vue&type=template&id=3d75732b"
import script from "./CastMovie.vue?vue&type=script&lang=js"
export * from "./CastMovie.vue?vue&type=script&lang=js"
script.render = render

export default script